import { render, staticRenderFns } from "./GroupBulkAssignModal.vue?vue&type=template&id=105c94f2&scoped=true&"
import script from "./GroupBulkAssignModal.vue?vue&type=script&lang=js&"
export * from "./GroupBulkAssignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105c94f2",
  null
  
)

export default component.exports